const getDefaultState = () => {
	return {
	}
}

export default getDefaultState
